import { OrdersPerformance } from '@/ducks/performance/performance.types'

const COLOR_BY_STATUS = {
  inprogress: '#2875eb',
  delivered: '#462c7a',
  returned: '#ffc631',
  cancelled: '#ff8f24'
}

export function compileChartData(performanceData: OrdersPerformance) {
  const { cancelled, delivered, returned, inprogress, accepted } =
    performanceData

  return {
    labels: ['In progress', 'Delivered', 'Returned', 'Cancelled'],
    datasets: [
      {
        total: accepted.count,
        cutout: '35%',
        data: [
          { count: inprogress.count, percentage: inprogress.percentage },
          { count: delivered.count, percentage: delivered.percentage },
          { count: returned.count, percentage: returned.percentage },
          { count: cancelled.count, percentage: cancelled.percentage }
        ],
        backgroundColor: [
          COLOR_BY_STATUS.inprogress,
          COLOR_BY_STATUS.delivered,
          COLOR_BY_STATUS.returned,
          COLOR_BY_STATUS.cancelled
        ],
        borderWidth: 0
      }
    ]
  }
}

export const DEFAULT_OPTIONS = {
  parsing: {
    key: 'count'
  },
  plugins: {
    legend: {
      display: false
    }
  }
}

export function compileLegendData(ordersPerformance: OrdersPerformance) {
  const { accepted, inprogress, delivered, returned, cancelled } =
    ordersPerformance

  return {
    accepted: accepted.count,
    types: [
      {
        label: 'orders.statuses.in-progress',
        count: inprogress.count,
        percentage: inprogress.percentage,
        backgroundColor: COLOR_BY_STATUS.inprogress
      },
      {
        label: 'orders.statuses.delivered',
        count: delivered.count,
        percentage: delivered.percentage,
        backgroundColor: COLOR_BY_STATUS.delivered
      },
      {
        label: 'orders.statuses.returned',
        count: returned.count,
        percentage: returned.percentage,
        backgroundColor: COLOR_BY_STATUS.returned
      },
      {
        label: 'orders.statuses.canceled',
        count: cancelled.count,
        percentage: cancelled.percentage,
        backgroundColor: COLOR_BY_STATUS.cancelled
      }
    ]
  }
}
